import {TFunction} from "react-i18next";
import {ColumnsType} from "antd/lib/table/interface";
import {Link} from "react-router-dom";
import {Date} from "../../core/commons/date/date";
import React from "react";
import {Price} from "../../core/commons/price/price";
import {Statement, StatementPaymentStatus} from "../../../models/accounting/statements";
import {Space, Tag} from "antd";
import {PaymentStatus} from "./ui/status/status";

export const columnsFactory = (t: TFunction<"translation">, currencyCode: string): ColumnsType<Statement> => {
    return [
        {
            title: t("INVOICE.NUMBER"),
            dataIndex: "number",
            key: "number",
            render: (number: string, item) => {
                switch (item.type) {
                    case "merged_invoice":
                        return <Link to={"/final-invoices/" + item.id}>
                            <span style={{whiteSpace: "nowrap"}}>{number}</span>
                        </Link>
                    case "credit_invoice":
                        return <Link to={"/credit-invoices/" + item.id}>
                            <span style={{whiteSpace: "nowrap"}}>{number}</span>
                        </Link>
                    default:
                        return "-";
                }
            }
        },
        {
            title: t("STATUS"),
            dataIndex: "paymentStatus",
            key: "paymentStatus",
            render: (status: StatementPaymentStatus) => <PaymentStatus status={status} />
        },
        {
            title: t("DUE_DATE"),
            dataIndex: "dueDate",
            key: "dueDate",
            render: (date: string, item) => <Space direction={"horizontal"}>
                {item.type === "merged_invoice" ? (<>
                    <div style={item.paymentStatus === 'overdue' ? ({color: "red"}) : ({})}>
                        <Date dateString={date} />
                    </div>
                </>) : <>-</>}
            </Space>,
        },
        {
            title: <b>{t("ENDING_BALANCE")}</b>,
            dataIndex: "endingBalance",
            key: "endingBalance",
            render: (v, item) => <div style={item.overdue && item.type === "merged_invoice" ? ({color: "red"}) : ({})}>
                <Price value={{value: v, currencyCode: currencyCode}}/>
            </div>
        },
        {
            title: t("SUBTOTAL"),
            dataIndex: "subtotal",
            key: "subtotal",
            render: v => <Price value={{value: v, currencyCode: currencyCode}} />
        },
        {
            title: t("TAX.TITLE"),
            dataIndex: "tax",
            key: "tax",
            render: v => <Price value={{value: v, currencyCode: currencyCode}} />
        },
        {
            title: t("GRAND_TOTAL_PRICE"),
            dataIndex: "grandtotal",
            key: "grandtotal",
            render: v => <Price value={{value: v, currencyCode: currencyCode}} />
        },
        {
            title: t("DATE"),
            dataIndex: "date",
            key: "date",
            render: (date: string) => <Date dateString={date} />,
        }
    ]
}